module.exports = __webpack_public_path__ + "static/media/EE_1.2a02b4e7.PNG";